import { getProjectsResponseSchema, projectSchema, createProjectResponseSchema, } from '@consigli/types';
import { createTransformer, createParams, mapToSnakeCase, } from './shared/base-api';
export const projectApiEndpoints = (builder, coreApiBaseUrl) => ({
    getProjects: builder.query({
        query: ({ page, pageSize, search, isHidden, ordering, packageTypes, createdBy, organization, }) => {
            // Every key has to be named twice — the destructure and createParams —
            // or it is silently dropped from the request.
            const params = createParams({
                page,
                pageSize,
                search,
                isHidden,
                ordering,
                packageTypes,
                createdBy,
                organization,
            });
            return {
                url: `${coreApiBaseUrl}/projects/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['Projects'],
        transformResponse: createTransformer(getProjectsResponseSchema, 'GetProjects'),
    }),
    getProject: builder.query({
        query: ({ projectId, isHidden }) => {
            const params = createParams({ isHidden });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['Projects'],
        transformResponse: createTransformer(projectSchema, 'GetProject'),
    }),
    createProject: builder.mutation({
        query: (project) => ({
            url: `${coreApiBaseUrl}/projects/`,
            method: 'POST',
            body: mapToSnakeCase(project),
        }),
        invalidatesTags: ['Projects', 'Users'],
        transformResponse: createTransformer(createProjectResponseSchema, 'CreateProject'),
    }),
    deleteProject: builder.mutation({
        query: ({ projectId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['Projects', 'DocumentPackages', 'Blobs', 'Findings'],
    }),
    updateProject: builder.mutation({
        query: ({ projectId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/`,
            method: 'PATCH',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: ['Projects'],
        transformResponse: createTransformer(projectSchema, 'UpdateProject'),
    }),
    removeProjectAccess: builder.mutation({
        query: ({ userId, projectId }) => ({
            url: `${coreApiBaseUrl}/accounts/${userId}/remove-project-access/`,
            method: 'POST',
            body: mapToSnakeCase({ projectId }),
        }),
        invalidatesTags: ['Users'],
    }),
});
